import React from 'react'
import { withIcon } from '../../withIcon'

function SubmitArrowIcon (props) {
  const {
    size = '16px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path d="M8 13V3M8 3L3 8M8 3L13 8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default withIcon(SubmitArrowIcon)
